<template>
  <div class="card">
    <div class="pb-0 card-header mb-0 border-bottom text-center opacity-7">
      <h6>{{ props.title }}</h6>
    </div>
    <div class="p-3 card-body">
      <div class="chart">
        <canvas :id="props.id" class="chart-canvas" height="300"></canvas>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, onMounted } from "vue";
import Chart from "chart.js/auto/auto.js";
import useDashboard from "@/composables/useDashboard";

const { chartsOptions, chartColors } = useDashboard();

console.log(chartsOptions.value);

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  id: {
    type: String,
    required: true,
  },
  labels: {
    type: Array,
    required: true,
  },
  data: {
    type: Array,
    required: true,
  },
  type: {
    type: String,
    default: "bar",
  },
});

onMounted(() => {
  var ctx1 = document.getElementById(props.id).getContext("2d");

  new Chart(ctx1, {
    type: props.type,
    data: {
      labels: props.labels,
      datasets: [
        {
          label: props.title,
          borderColor: chartColors.value,
          backgroundColor: chartColors.value,
          fill: true,
          data: props.data,
        },
      ],
    },
    options: chartsOptions.value,
  });
});
</script>
